const papersDataCambridgeInternationalAlevel = {
  mathematics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_ms_43.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_qp_53.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_ms_53.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_qp_63.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9709_s25_ms_63.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2024-May-June/9709_s24_ms_61.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/567744-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567738-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/mathematics-9709/2023/9709_s23_qp_21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567739-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/Images/567746-june-2023-question-paper-31.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/mathematics-9709/2023/9709_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/mathematics-9709/2023/9709_s23_qp_41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/673787-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cambridgeinternational.org/Images/673795-june-2023-question-paper-51.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/mathematics-9709/2023/9709_s23_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cambridgeinternational.org/Images/673797-june-2023-question-paper-61.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/673791-june-2023-mark-scheme-paper-61.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2022-May-June/9709_s22_ms_61.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_qp_61.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Mathematics-9709/2021-May-June/9709_s21_ms_61.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/415312-2020-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/415335-2020-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/api/file/caie/A-Level/Mathematics-9709/Syllabus%20&%20Specimen/9709_y20_sp_2.pdf',
          marking:
            'https://pastpapers.co/caie/A-Level/Mathematics-9709/Syllabus%20&%20Specimen/9709_y20_sm_2.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/Images/415315-2020-specimen-paper-3.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/415339-2020-specimen-paper-3-mark-scheme.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/415317-2020-specimen-paper-4.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Maths/A-level/Papers/CIE/CAIE/Mechanics-1/MS/Specimen%202020%20MS.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cambridgeinternational.org/Images/415319-2020-specimen-paper-5.pdf',
          marking:
            'https://www.cambridgeinternational.org/images/415319-2020-specimen-paper-5.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.mymathscloud.com/api/download/modules/A-Level/Past-Papers/Cambridge-(CAIE)-9709-and-9231/P6/9709%20Specimen%202020%20P6.pdf?id=20055996',
          marking:
            'https://www.learnedguys.com/uploads/files/2087/9709_Specimen_Paper_Answers_Paper_6_(for_examination_from_2020).pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_ms_51.pdf',
        },
        {
          label: 'Paper 6',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_qp_61.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9709_s19_ms_61.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_ms_43.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_qp_53.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9700_s25_ms_53.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_33.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_42.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_qp_52.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2024-March/9700_m24_ms_52.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/566829-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/566825-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/566827-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/566823-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/Images/566828-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/566824-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/606626-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/566826-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/biology-9700/2023/9700_s23_qp_52.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/606601-june-2023-mark-scheme-paper-51.pdf',
        },
      ],
    },
    {
      year: '2022 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/554306-2022-specimen-paper-1.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Biology/A-level/Past-Papers/CAIE/Paper-1/MS/Specimen%202022%20MS.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pmt.physicsandmathstutor.com/download/Biology/A-level/Past-Papers/CAIE/Paper-2/QP/Specimen%202022%20QP.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Biology/A-level/Past-Papers/CAIE/Paper-2/MS/Specimen%202022%20MS.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pmt.physicsandmathstutor.com/download/Biology/A-level/Past-Papers/CAIE/Paper-3/QP/Specimen%202022%20QP.pdf',
          marking:
            'https://pastpapers.co/api/file/caie/A-Level/Biology-9700/Syllabus%20&%20Specimen/9700_y22_sm_3.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pmt.physicsandmathstutor.com/download/Biology/A-level/Past-Papers/CAIE/Paper-4/QP/Specimen%202022%20QP.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/554295-2022-specimen-paper-4-mark-scheme.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cambridgeinternational.org/Images/554302-2022-specimen-paper-5.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/554296-2022-specimen-paper-5-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2021-May-June/9700_s21_ms_51.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Biology-9700/2020-May-June/9700_s20_ms_51.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/11/9700_s19_ms_51.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_ms_43.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_qp_53.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9701_s25_ms_53.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_33.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_42.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_qp_52.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2024-March/9701_m24_ms_52.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/567201-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567193-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/567197-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567189-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/Images/567199-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567190-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/606634-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/606629-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cambridgeinternational.org/Images/606635-june-2023-question-paper-51.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/606630-june-2023-mark-scheme-paper-51.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2022-May-June/9701_s22_ms_51.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Chemistry-9701/2021-May-June/9701_s21_ms_51.pdf',
        },
      ],
    },
    {
      year: '2020 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/chemistry-9701/2020/9701_s20_qp_11.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/chemistry-9701/2020/9701_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/554354-2022-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/554342-2022-specimen-paper-2-mark-scheme.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/chemistry-9701/2020/9701_s20_qp_31.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/chemistry-9701/2020/9701_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/554356-2022-specimen-paper-4.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/chemistry-9701/2020/9701_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/chemistry-9701/2020/9701_s20_qp_51.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/chemistry-9701/2020/9701_s20_ms_51.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9701_s19_ms_51.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_ms_43.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_qp_53.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9702_s25_ms_53.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2024-May-June/9702_s24_ms_51.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/physics-9702/2023/9702_s23_qp_11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567865-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/physics-9702/2023/9702_s23_qp_21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567863-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/physics-9702/2023/9702_s23_qp_31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567864-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/physics-9702/2023/9702_s23_qp_41.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/physics-9702/2023/9702_s23_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/physics-9702/2023/9702_s23_qp_51.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/physics-9702/2023/9702_s23_ms_51.pdf',
        },
      ],
    },
    {
      year: '2022 (Specimen)',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/554384-2022-specimen-paper-1.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/554369-2022-specimen-paper-1-mark-scheme.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/554386-2022-specimen-paper-2.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/554371-2022-specimen-paper-2-mark-scheme.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cambridgeinternational.org/Images/554389-2022-specimen-paper-3.pdf',
          marking:
            'https://pmt.physicsandmathstutor.com/download/Physics/A-level/Past-Papers/CAIE/Paper-3/MS/Specimen%202022%20MS.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cambridgeinternational.org/Images/554396-2022-specimen-paper-4.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/554376-2022-specimen-paper-4-mark-scheme.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pmt.physicsandmathstutor.com/download/Physics/A-level/Past-Papers/CAIE/Paper-5/QP/Specimen%202022%20QP.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/554378-2022-specimen-paper-5-mark-scheme.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2021-May-June/9702_s21_ms_51.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_qp_51.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Physics-9702/2020-May-June/9702_s20_ms_51.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_ms_41.pdf',
        },
        {
          label: 'Paper 5',
          link:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_qp_51.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2020/01/9702_s19_ms_51.pdf',
        },
      ],
    },
  ],
  economics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9708_s25_qp_13.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9708_s25_ms_13.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9708_s25_qp_23.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9708_s25_ms_23.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9708_s25_qp_33.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9708_s25_ms_33.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9708_s25_qp_43.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9708_s25_ms_43.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_qp_22.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_ms_22.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_qp_32.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_ms_32.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_qp_42.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2024-March/9708_m24_ms_42.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cambridgeinternational.org/Images/567341-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567337-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cambridgeinternational.org/Images/567342-june-2023-question-paper-21.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/economics-9708/2023/9708_s23_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/economics-9708/2023/9708_s23_qp_31.pdf',
          marking:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/economics-9708/2023/9708_s23_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://bestexamhelp.com/exam/cambridge-international-a-level/economics-9708/2023/9708_s23_qp_41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/673736-june-2023-mark-scheme-paper-41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2022-May-June/9708_s22_ms_41.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_qp_12.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_ms_12.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_ms_22.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2021-May-June/9708_s21_ms_41.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_qp_11.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_qp_21.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_qp_31.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_qp_41.pdf',
          marking:
            'https://pastpapers.co/cie/A-Level/Economics-9708/2020-May-June/9708_s20_ms_41.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: 'Paper 1',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9708_s19_qp_11.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9708_s19_ms_11.pdf',
        },
        {
          label: 'Paper 2',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9708_s19_qp_21.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9708_s19_ms_21.pdf',
        },
        {
          label: 'Paper 3',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9708_s19_qp_31.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9708_s19_ms_31.pdf',
        },
        {
          label: 'Paper 4',
          link:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9708_s19_qp_41.pdf',
          marking:
            'https://www.cienotes.com/wp-content/uploads/2019/12/9708_s19_ms_41.pdf',
        },
      ],
    },
  ],
  business: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s25_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s25_ms_31.pdf',
        },
        {
          label: 'Insert 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s25_in_31.pdf',
          marking: '',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s25_ms_41.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s24_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s24_ms_31.pdf',
        },
        {
          label: 'Insert 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s24_in_31.pdf',
          marking: '',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/566852-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/566849-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/566851-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/566848-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://www.cambridgeinternational.org/Images/566850-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/566847-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Insert 03',
          link:
            'https://www.cambridgeinternational.org/Images/566846-june-2023-insert-paper-31.pdf',
          marking: '',
        },
        {
          label: 'Paper 04',
          link:
            'https://www.cambridgeinternational.org/Images/726239-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/726237-june-2023-mark-scheme-paper-41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s22_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s22_ms_31.pdf',
        },
        {
          label: 'Insert 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9609_s22_in_31.pdf',
          marking: '',
        },
      ],
    },
  ],
  accounting: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_ms_31.pdf',
        },
        {
          label: 'Insert 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_in_31.pdf',
          marking: '',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_ms_41.pdf',
        },
        {
          label: 'Insert 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s25_in_41.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_ms_31.pdf',
        },
        {
          label: 'Insert 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_in_31.pdf',
          marking: '',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_ms_41.pdf',
        },
        {
          label: 'Insert 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s24_in_41.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/566476-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/566474-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/566475-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/606643-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://www.cambridgeinternational.org/Images/606648-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/566473-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Insert 03',
          link:
            'https://www.cambridgeinternational.org/Images/644964-june-2023-insert-paper-31.pdf',
          marking: '',
        },
        {
          label: 'Paper 04',
          link:
            'https://www.cambridgeinternational.org/Images/725801-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/725799-june-2023-mark-scheme-paper-41.pdf',
        },
        {
          label: 'Insert 04',
          link:
            'https://www.cambridgeinternational.org/Images/644965-9706-june-2023-insert-paper-41.pdf',
          marking: '',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s22_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s22_ms_31.pdf',
        },
        {
          label: 'Insert 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9706_s22_in_31.pdf',
          marking: '',
        },
      ],
    },
  ],
  englishlanguage: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s25_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s25_ms_31.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s25_ms_41.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s24_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s24_ms_31.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/567374-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567370-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/567375-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567371-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://www.cambridgeinternational.org/Images/567376-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567372-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://www.cambridgeinternational.org/Images/672628-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/672624-june-2023-mark-scheme-paper-41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s22_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s22_ms_31.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s22_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9093_s22_ms_41.pdf',
        },
      ],
    },
  ],
  furthermathematics: [
    {
      year: '2025',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s25_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s25_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s25_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s25_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s25_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s25_ms_31.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s25_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s25_ms_41.pdf',
        },
      ],
    },
    {
      year: '2024',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s24_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s24_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s24_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s24_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s24_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s24_ms_31.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s24_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s24_ms_41.pdf',
        },
      ],
    },
    {
      year: '2023',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://www.cambridgeinternational.org/Images/567730-june-2023-question-paper-11.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567728-june-2023-mark-scheme-paper-11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://www.cambridgeinternational.org/Images/567731-june-2023-question-paper-21.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/567729-june-2023-mark-scheme-paper-21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://www.cambridgeinternational.org/Images/643733-june-2023-question-paper-31.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/643731-june-2023-mark-scheme-paper-31.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://www.cambridgeinternational.org/Images/673164-june-2023-question-paper-41.pdf',
          marking:
            'https://www.cambridgeinternational.org/Images/673162-june-2023-mark-scheme-paper-41.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: 'Paper 01',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s22_qp_11.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s22_ms_11.pdf',
        },
        {
          label: 'Paper 02',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s22_qp_21.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s22_ms_21.pdf',
        },
        {
          label: 'Paper 03',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s22_qp_31.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s22_ms_31.pdf',
        },
        {
          label: 'Paper 04',
          link:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s22_qp_41.pdf',
          marking:
            'https://pastpapers.papacambridge.com/directories/CAIE/CAIE-pastpapers/upload/9231_s22_ms_41.pdf',
        },
      ],
    },
  ],
};

export default papersDataCambridgeInternationalAlevel;
